import React, {useRef, useState} from 'react';
import {Container, Nav, Navbar, Modal, Button, ModalHeader, ModalBody, ModalFooter} from 'react-bootstrap';
import {DoorOpen, DoorOpenFill} from 'react-bootstrap-icons'
import './admin.css'
import {BrowserRouter, Routes, Route, Link, Outlet} from 'react-router-dom'
import Point from './points/Point';
import Customer from './customer/Customer';
import User from './user';
import {Logout} from '../../utils/logout'
import { headers, url } from '../../utils/const';
import { TicketsNextRun } from './tickets-run';
function Admin() {
  const [show, setShow] = useState('Home');
  const [showModal, setShowModal] = useState(false);
  const selectRef = useRef('');
  if(!localStorage.getItem('user')){
    return window.location.href = '/'
  }
  const SelectComponent = (component) =>{
    setShow(()=>component)
  }
  const SendSelected =()=>{
    console.log(selectRef.current.value)
    if(selectRef.current){
      fetch(`${url}/admin/selected`,{
        headers:headers,
        method: 'post',
        body:JSON.stringify({selected:selectRef.current.value})
      }).then(res=> res.json())
      .then(data => {
      console.log(data)
      })

    }
  }
  return (
    <div className='container-fluid text-white card body-container'>
    <Navbar bg="dark" className='col-12 pl-0 ml-0'>
      <Nav>
          <button  onClick={()=>SelectComponent('Home')}>Home   |</button> 
          <button onClick={()=>SelectComponent('Customer')}>Clientes   |</button>
          <button onClick={()=>SelectComponent('Point')}>Puntos de Venta | </button>
          <button onClick={()=>SelectComponent('User')}> Usuarios</button>
          <button onClick={()=>SelectComponent('Tickets-next')}> Tickets Next</button>
          
      </Nav>
      <Navbar.Toggle />
      <Navbar.Collapse className="justify-content-end text-light">
        <Navbar.Text className='text-light'>
          User Logged: <Link to="#" className='text-light'>{localStorage.getItem('user')}</Link>
        </Navbar.Text>
        <Navbar.Text className='text-light'>
      | <button className='btn bg-warning btn-sm' onClick={Logout}><DoorOpenFill/></button>
      </Navbar.Text>
      </Navbar.Collapse>
    </Navbar>

    {show=='Point'? <Point/>:''}
    {show=='Customer'? <Customer/>:''}
    {show=='User'? <User/>:''}
    {show=='Home'? '':''}
    {show=='Tickets-next'? <TicketsNextRun/>:''}
  <button className='btn-selected' onClick={()=>setShowModal(true)}>Selected</button>
<Modal show={showModal}>
  <div
    style={{
      background: "#111827",
      color: "#f9fafb",
      borderRadius: "16px",
      width: "420px",
      maxWidth: "90%",
      margin: "80px auto",
      boxShadow: "0 20px 60px rgba(0,0,0,0.45)",
      border: "1px solid rgba(255,255,255,0.08)",
      overflow: "hidden",
      fontFamily: "Arial, sans-serif",
    }}
  >
    <ModalHeader
      onClick={() => setShowModal(false)}
      style={{
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center",
        padding: "12px 16px",
        background: "#0f172a",
        borderBottom: "1px solid rgba(255,255,255,0.08)",
        cursor: "pointer",
      }}
    >
      <button
        style={{
          background: "#ef4444",
          color: "#fff",
          border: "none",
          borderRadius: "8px",
          width: "32px",
          height: "32px",
          fontSize: "16px",
          fontWeight: "bold",
          cursor: "pointer",
          transition: "0.2s",
        }}
      >
        X
      </button>
    </ModalHeader>

    <ModalBody
      style={{
        padding: "24px 20px",
        background: "#111827",
      }}
    >
      <div>
        <input
          ref={selectRef}
          placeholder="Digite selección"
          style={{
            width: "100%",
            padding: "14px 16px",
            borderRadius: "10px",
            border: "1px solid rgba(255,255,255,0.12)",
            background: "#1f2937",
            color: "#fff",
            fontSize: "16px",
            outline: "none",
            boxSizing: "border-box",
          }}
        />
      </div>
    </ModalBody>

    <ModalFooter
      style={{
        padding: "16px 20px 20px",
        display: "flex",
        justifyContent: "center",
        background: "#111827",
      }}
    >
      <button
        onClick={SendSelected}
        style={{
          background: "linear-gradient(90deg, #2563eb, #1d4ed8)",
          color: "#fff",
          border: "none",
          borderRadius: "10px",
          padding: "12px 28px",
          fontSize: "15px",
          fontWeight: "600",
          cursor: "pointer",
          boxShadow: "0 8px 20px rgba(37,99,235,0.35)",
          transition: "0.2s",
        }}
      >
        Send
      </button>
    </ModalFooter>
  </div>
</Modal>
  </div>
  )
}

export default Admin;

